import { UseQueryResult } from "@tanstack/react-query";
import { BUModuleResponseModel } from "../api/types";
import useAccessibilityModalStore from "../store";
import { CenteredLoadingIndicator } from "../../../sessions/components/centered-loading-indicator";
import { ModuleItem } from "../../accessibility-management/components/module-item";
import { PrefixIcon } from "./prefix-icon";

interface IModules {
  getAccess: UseQueryResult<BUModuleResponseModel, Error>;
}

export const Modules: React.FC<IModules> = ({ getAccess }) => {
  const { isFetching, isLoading } = getAccess;
  const loading = isFetching || isLoading;
  const {
    modules,
    toggleModule,
    togglePrivilege,
    enableAllPrivilegesInModule,
  } = useAccessibilityModalStore();
  return (
    <>
      {loading && <CenteredLoadingIndicator />}
      {!loading &&
        modules.map((module) => (
          <ModuleItem
            key={module.id}
            disabled={module.name === "User Profile"}
            item={module}
            isSelected={module.enable}
            prefixIcon={
              <PrefixIcon name={module.name} enable={module.enable} />
            }
            onSelectModule={toggleModule}
            onSelectPrivilege={togglePrivilege}
            onAllowFullAccess={enableAllPrivilegesInModule}
          />
        ))}
    </>
  );
};
